module.exports = __webpack_public_path__ + "static/media/stroke.8d63b641.mp3";